function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M8.5001 1.59998C4.9657 1.59998 2.1001 4.46558 2.1001 7.99998C2.1001 11.5344 4.9657 14.4 8.5001 14.4C12.0345 14.4 14.9001 11.5344 14.9001 7.99998C14.9001 4.46558 12.0345 1.59998 8.5001 1.59998ZM8.5001 12C8.0585 12 7.7001 11.6416 7.7001 11.2C7.7001 10.7584 8.0585 10.4 8.5001 10.4C8.9417 10.4 9.3001 10.7584 9.3001 11.2C9.3001 11.6416 8.9417 12 8.5001 12ZM9.60303 8.26664C9.24997 8.59251 9.03343 8.80638 9.03343 9.06664H7.96676C7.96676 8.32584 8.4729 7.85864 8.8793 7.48264C9.30543 7.08904 9.56676 6.82611 9.56676 6.39998C9.56676 5.81171 9.08836 5.33331 8.5001 5.33331C7.91183 5.33331 7.43343 5.81171 7.43343 6.39998H6.36676C6.36676 5.22344 7.32356 4.26664 8.5001 4.26664C9.67663 4.26664 10.6334 5.22344 10.6334 6.39998C10.6334 7.31464 10.0622 7.84211 9.60303 8.26664Z",
  fill: "#291452",
  fillOpacity: 0.3
}));

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.2bbf5a3b.svg";
export { ForwardRef as ReactComponent };